import {onlyNumbers} from "@/services/phone.helper"

const isValidSnils = (snils) => {
	// Удаляем все нецифровые символы
	const cleanedSnils = snils.replace(/\D/g, '');

	// Проверяем, что длина номера - 11 цифр
	if (cleanedSnils.length !== 11) {
		return false;
	}

	let sum = 0;
	for (let i = 0; i < 9; i++) {
		sum += parseInt(cleanedSnils[i]) * (9 - i);
	}

	let controlNumber = sum % 101;

	if (controlNumber === 100) {
		controlNumber = 0;
	}

	const calculatedControl = parseInt(cleanedSnils.substring(9));

	return controlNumber === calculatedControl;
}

function forceSnilsFormat(input) {
	const digits = onlyNumbers(input)

	if (digits.length !== 11) return input

	return digits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1-$2-$3 $4');
}

export { isValidSnils, forceSnilsFormat }
